import styled, { createGlobalStyle } from 'styled-components/macro';
import { spacing } from '@material-ui/system';
import { Paper, Divider } from '@material-ui/core';

import { GlobalStyleProps } from '../../types/styles';

export const DRAWER_WIDTH = 258;

export const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.palette.background.default};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

export const StyledRoot = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const StyledDrawer = styled.div`
  ${props => props.theme.breakpoints.up('md')} {
    width: ${DRAWER_WIDTH}px;
    flex-shrink: 0;
  }
`;

export const StyledAppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledPaper = styled(Paper)(spacing);

export const StyledMainContent = styled(StyledPaper)`
  flex: 1;
  background: ${props => props.theme.palette.background.default};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`;

export const StyledDivider = styled(Divider)(spacing);
